import React, { useState,useEffect } from 'react'
import {Link,NavLink,useLocation} from 'react-router-dom'
import {Offcanvas} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import GptAd from '../ads/gptAd';
// import GoogleAd from '../adds/googleAds';


const photosHeaderTopLinks=[{text:"TOne Home",link:"https://www.teluguone.com"},{text:"NEWS",link:"https://www.teluguone.com/news"},{text:"MOVIE NEWS",link:"https://www.teluguone.com/tmdb"},
    {text:"BHAKTI",link:"https://www.teluguone.com/devotional"},{text:"GRANDALAYAM",link:"https://www.teluguone.com/grandalayam"},{text:"SHORTFILMS",link:"https://www.teluguone.com/shortfilms"},
    {text:"VIDEOS",link:"https://www.teluguone.com/videos"},{text:"KIDSONE",link:"http://www.kidsone.in/"},{text:"TORi(Radio)",link:"https://www.teluguoneradio.com"},
    {text:"RECIPES",link:"https://www.teluguone.com/recipes"},
  {text:"VANITHA",link:"https://www.teluguone.com/vanitha"},{text:"ASTROLOGY",link:"https://www.teluguone.com/toneastrology"},{text:"COMEDY",link:"https://www.teluguone.com/comedy"},
  {text:"NRI",link:"https://www.teluguone.com/nri"},{text:"GREETINGS",link:"https://www.teluguone.com/tonegreetings"},{text:"HEALTHY",link:"https://www.teluguone.com/health"},{text:"CHARITY",link:"https://www.teluguonefoundation.in/index.html"}]


  
const photosHeaderBottomLinks=[{text:"HOME",link:"/"},{text:"ACTORS",link:"/pages/actors-2.html"},{text:"ACTRESS",link:"/pages/actress-1.html"},
  {text:"EVENTS",link:"/pages/events-10.html"},
  {text:"KINGSIZE",link:"/pages/kingsize-11.html"},{text:"MOVIES",link:"/pages/movies-8.html"},
  {text:"OTHERS",link:"/pages/others-12.html"},{text:"WALLPAPERS",link:"/pages/wallpapers-9.html"}]




const mobileMenuLinks = [
  { text: 'TOne Home', link:"https://www.teluguone.com" },
  { text: "News", link: "https://www.teluguone.com/news" },
  { text: "Movie News", link: "https://www.teluguone.com/tmdb" },
  { text: "Movies", link: "https://www.teluguone.com/movies" },
  { text: "Photos", link: "https://www.teluguone.com/photos" },
  { text: "Grandalayam", link: "https://www.teluguone.com/grandalayam" },
  { text: "Shortfilms", link: "https://www.teluguone.com/shortfilms" },
  { text: "Bakthi", link: "https://www.teluguone.com/devotional" },
  { text: "Videos", link: "https://www.teluguone.com/videos" },
  { text: "Recipes", link: "https://www.teluguone.com/recipes" },
  { text: "Comedy", link: "https://www.teluguone.com/comedy" },
  { text: "Vanitha", link: "https://www.teluguone.com/vanitha" }
];


const categoryLocations={
      "-1-":"ACTRESS",
      "-2-":"ACTORS",
      "-10-":"EVENTS",
      "-8-":"MOVIES",
      "-9-":"WALLPAPERS",
      "-11-":"KINGSIZE",
      "-12-":"OTHERS",
        "-1.":"ACTRESS",
      "-2.":"ACTORS",
      "-10.":"EVENTS",
      "-8.":"MOVIES",
      "-9.":"WALLPAPERS",
      "-11.":"KINGSIZE",
      "-12.":"OTHERS"
}

const menu = [
  { path: "/", label: "Home", end: true },
  { path: "/pages/actors-2.html", label: "Actors" },
  { path: "/pages/actress-1.html", label: "Actress" },
  { path: "/pages/events-10.html", label: "Events" },
  { path: "/pages/kingsize-11.html", label: "Kingsize" },
  { path: "/pages/movies-8.html", label: "Movies" },
  { path: "/pages/others-12.html", label: "Others" },
  { path: "/pages/wallpapers-9.html", label: "Wallpapers" }
];


function PhotosHeader() {
                        
                
                  const activeCategoryLocation =useLocation();
                 
   
                 
  return (
    <div className='photos-header-main'>
    
      <div className="topbar">
        <div className="topbar-inner">
         <div className="topbar-links">
        <a href="https://teluguone.com" target="_blank">TOne Home</a>
        <a href="https://www.teluguone.com/news/" target="_blank" >News</a>
        <a href="https://www.teluguone.com/tmdb/" target="_blank" >Movie News</a>
        <a href="https://www.teluguone.com/grandalayam/" target="_blank" >Grandalayam</a>
        <a href="https://www.teluguone.com/devotional/" target="_blank" >Bhakti</a>
        <a href="https://www.teluguone.com/sahityam/" target="_blank">Sahityam</a>
        <a href="https://www.teluguone.com/videos/" target="_blank" >Videos</a>
        <a href="http://www.kidsone.in" target="_blank">KidsOne</a>
        <a href="https://www.teluguoneradio.com" target="_blank">TORi Radio</a>
        <a href="https://www.teluguone.com/recipes/" target="_blank" >Recipes</a>
        <a href="https://www.teluguone.com/movies/" target="_blank" >Movies</a>
        <a href="https://www.teluguone.com/comedy/" target="_blank" >Comedy</a>
        <a href="https://www.teluguone.com/greetings/" target="_blank" >Greetings</a>
        <a href="https://www.teluguone.com/nrinews/" target="_blank" >NRI Corner</a>
        <a href="https://www.teluguonefoundation.in" target="_blank">Charity</a>
        <a href="https://www.teluguone.com/morelinks" target="_blank" >More...</a>
         </div>
        
    </div>
        </div>

         <PhotosMobileHeader />


   
  <header className="site-header">
    <div className="header-inner">
      <Link to="/" className="logo-wrap">
        <div className="logo-div">
         

          <img src="/photos/assets/images/photos_logo.gif" alt="header-logo" className="l" />

          
        </div>
      </Link>
      <div className="header-ad-slot">
            <div style={{
  margin: '5px 0 10px 0',
  width: '100%',
  height: 'auto',
  textAlign: 'center'
}}>
   <GptAd id="div-gpt-header" />
            </div>
      </div>
      
    </div>
  </header>

 
  <nav className="primary-nav">
    <div className="nav-inner">
      <ul className="nav-list" id="navList">
        {menu.map((item) => (
  <li key={item.path}>
    <NavLink
      to={item.path}
      end={item.end}
      className={({ isActive }) => isActive ? "active" : ""}
    >
      {item.label}
    </NavLink>
  </li>
))}
      </ul>
    </div>
  </nav>

      


   
    </div>
  )
}

export default PhotosHeader;



function  PhotosMobileHeader() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='photos-mobile-header'>
      <Button  variant="primary" onClick={handleShow}>
      <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M4 7h22M4 15h22M4 23h22"></path></svg>
      </Button>

      <Offcanvas className="photos-mobile-offcanvas"  show={show}
  onHide={handleClose}
  placement="start">
        <Offcanvas.Header closeButton>
        <img   src={`/photos/assets/images/tone_logo.webp`}
                        alt="tone-logo" className="header-logo"/>

        
        </Offcanvas.Header>
        <Offcanvas.Body>
            <nav className="photos-mobile-header-menu">
                {mobileMenuLinks.map((item,index) => <Link className='photos-mobile-menu-link' rel="noopener noreferrer"  key={index} to={item.link}>{item.text}</Link>)}
             
            </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
